import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    loading: false,
    list: false,
    paymentDetail: {
      id: "",
      docsPerMonth: "",
      nameTH: "",
      nameEN: "",
      pricePerExDoc: "",
      pricePerMonth: "",
      pricePerYear: "",
    },
    paymentNextDetail: {
      id: "",
      docsPerMonth: "",
      nameTH: "",
      nameEN: "",
      pricePerExDoc: "",
      pricePerMonth: "",
      pricePerYear: "",
    },
  },
  mutations: {
    setList(state, val) {
      state.list = val
    },
    setPaymentDetail(state, val) {
      state.paymentDetail = val
    },
    setPaymentNextDetail(state, val) {
      state.paymentNextDetail = val
    },
  },
  actions: {
    getDetail({commit}, {paymentPlanID, nextPlan}) {
      fc.db.collection('PaymentPlans').doc(paymentPlanID).get().then(function (paymentPlanDetail) {
        let detail = paymentPlanDetail.data()
        detail.id = paymentPlanDetail.id
        if(nextPlan){
           commit('setPaymentNextDetail', detail)
        }else {
           commit('setPaymentDetail', detail)
        }
      })
    },
    getList({commit}) {
      fc.db.collection('PaymentPlans').get()
        .then(function (payment_plant) {
          let list = [];
          payment_plant.forEach(doc => {
            list[doc.id] = doc.data()
          });
          // console.log(list)
          commit('setList', list)

        })
        .catch(function (error) {
          console.log("error", error)
        })
    }
  },
}
